import { API_GET_ALL_ROADS } from "actions/road";

export function getAllRoads(date, sync = false, external = false) {
	return {
		type: API_GET_ALL_ROADS,
		payload: {
			request: {
				url: `/roads`,
				params: {
					external,
					date,
					sync,
				},
			},
		},
	};
}
